import OrderOptimizerListParams, {
  OrderOptimizerListParamsStatus,
} from "../../../../../common/services/order-optimizer/list/order-optimizer-list-params";
import OrderOptimizerTaxiListingFilter, {
  OrderOptimizerTaxiListingIgnoreDriverRoutesFilter,
  OrderOptimizerTaxiListingMaximumDelayFilter,
  OrderOptimizerTaxiListingMaximumHaltingTimeFilter,
  OrderOptimizerTaxiListingOrderHumanIdFilter,
} from "./types/order-optimizer-taxi-listing-filter";
import OrderOptimizerTaxiListingFilterType from "./types/order-optimizer-taxi-listing-filter-type";
import { OrderOptimizerTaxiListingItemStatus } from "./types/order-optimizer-taxi-listing-item";

const createStatus = (
  status: OrderOptimizerTaxiListingItemStatus,
): OrderOptimizerListParamsStatus => {
  switch (status) {
    case OrderOptimizerTaxiListingItemStatus.INTERESTING:
      return OrderOptimizerListParamsStatus.INTERESTING;
    case OrderOptimizerTaxiListingItemStatus.PENDING:
      return OrderOptimizerListParamsStatus.PENDING;
    case OrderOptimizerTaxiListingItemStatus.REJECTED:
      return OrderOptimizerListParamsStatus.REJECTED;
  }
};

const create = (
  filters: OrderOptimizerTaxiListingFilter[],
  page: number,
  pageSize: number,
): OrderOptimizerListParams => {
  const ignoreDriverRoutes = filters.find(
    (filter) =>
      filter.type === OrderOptimizerTaxiListingFilterType.IGNORE_DRIVER_ROUTES,
  )?.value as
    | OrderOptimizerTaxiListingIgnoreDriverRoutesFilter["value"]
    | undefined;

  const statusFilter = filters.find(
    (filter) => filter.type === OrderOptimizerTaxiListingFilterType.STATUS,
  )?.value;

  return {
    orderHumanId: filters.find(
      (filter) =>
        filter.type === OrderOptimizerTaxiListingFilterType.ORDER_HUMAN_ID,
    )?.value as
      | OrderOptimizerTaxiListingOrderHumanIdFilter["value"]
      | undefined,
    page: page,
    pageSize: pageSize,
    maximumDelay: filters.find(
      (filter) =>
        filter.type === OrderOptimizerTaxiListingFilterType.MAXIMUM_DELAY,
    )?.value as
      | OrderOptimizerTaxiListingMaximumDelayFilter["value"]
      | undefined,
    maximumHaltingTime: filters.find(
      (filter) =>
        filter.type ===
        OrderOptimizerTaxiListingFilterType.MAXIMUM_HALTING_TIME,
    )?.value as
      | OrderOptimizerTaxiListingMaximumHaltingTimeFilter["value"]
      | undefined,
    mergePlanEntries: ignoreDriverRoutes ? false : undefined,
    status:
      statusFilter && !statusFilter.exclude
        ? createStatus(statusFilter.status)
        : undefined,
    excludeStatus:
      statusFilter && statusFilter.exclude
        ? createStatus(statusFilter.status)
        : undefined,
  };
};

const orderOptimizerTaxiListingLoadParamsFactory = {
  create,
};

export default orderOptimizerTaxiListingLoadParamsFactory;
